import _ from 'lodash';

function replaceProject(projects, _id, updater) {
  const projectIx = _.findIndex(projects, { _id });
  const project = updater(projects[projectIx]);
  return [
    ...projects.slice(0, projectIx),
    project,
    ...projects.slice(projectIx + 1),
  ];
}

export default {
  setProjectList(state, payload) {
    state.data = payload;
  },
  setProjectId(state, projId) {
    state.selected = projId;
  },
  setProjectListStatus(state, payload) {
    if (payload !== 'Error') {
      state.errMessage = null;
    }
    state.status = payload;
  },
  setProjectListErrMessage(state, payload) {
    state.status = 'Error';
    state.errMessage = payload;
  },
  addProject(state, payload) {
    const currentProjects = state.data;
    state.data = [...currentProjects, payload];
  },
  CLEAR(state) {
    state.data = [];
    state.selected = null;
    state.status = 'Unfetched';
    state.errMessage = null;
  },
  UPDATING(state, { _id, name }) {
    state.data = replaceProject(
      state.data,
      _id,
      r => _.omit({ ...r, name, updating: true, oldName: r.name }, 'error'),
    );
  },
  UPDATED(state, { _id }) {
    state.data = replaceProject(
      state.data,
      _id,
      r => _.omit({ ...r, updating: false }, 'error', 'oldName'),
    );
  },
  UPDATE_ERROR(state, { _id, error }) {
    state.data = replaceProject(
      state.data,
      _id,
      r => ({ ...r, name: r.oldName, updating: false, error }),
    );
  },

};



// WEBPACK FOOTER //
// ./src/store/modules/projects/mutations.js